import React, { useContext } from 'react';
import { RulerContext } from '../../contexts/RulerContext';

const serifHeight = 20;


export function HorizontalRuler(props: {
    x: number;
    svgY: number;
    length: number;

}) {
    const {
        stroke,
        fontSize
    } = useContext(RulerContext);

    const x = props.x;
    const y = props.svgY + 10;

    const x2 = x + props.length;
    return (
        <g className="horizontal-ruler ruler">
            <line className="ruler-main-line" x1={x} y1={y} x2={x2} y2={y} stroke={stroke} />
            <line className="ruler-serif" x1={x} x2={x} y1={y - serifHeight} y2={y + serifHeight} stroke={stroke} />
            <line className="ruler-serif" x1={x2} x2={x2} y1={y - serifHeight} y2={y + serifHeight} stroke={stroke} />
            <text className="ruler-text"
                x={(x + x2) / 2}
                y={y - 6.5}
                textAnchor="middle"
                fontSize={fontSize}>
                {toDist(props.length)}
            </text>
        </g>
	);
}

export function toDist(length: number): string {
    //Don't display "cm" for very short distances
    const suffix = length > 250
        ? " cm"
        : "";
    return (length/10).toLocaleString(undefined, { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + suffix;
}

export module HorizontalRuler {
    export const height = 2 * serifHeight + 80;
}
